module.exports = __webpack_public_path__ + "img/qingsao.4d077672.png";